// extracted by mini-css-extract-plugin
export default {"container":"InnerReadWidget__container___FBEbX","title":"InnerReadWidget__title___SSgWt","debug":"InnerReadWidget__debug___abPKY"};